import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
    };

    this.isControlled = this.isControlled.bind(this);
    this.selectTabIndex = this.selectTabIndex.bind(this);
  }

  isControlled() {
    return this.props.activeIndex != null;
  }

  selectTabIndex(activeIndex) {
    if (!this.isControlled()) {
      this.setState({ activeIndex });
    } else {
      this.props.onChange(activeIndex);
    }
  }

  render() {
    const children = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        activeIndex: this.isControlled() ? this.props.activeIndex : this.state.activeIndex,
        onSelectTab: this.selectTabIndex,
      }),
    );

    return <div>{children}</div>;
  }
}

Tabs.propTypes = {
  activeIndex: PropTypes.number,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
};

Tabs.defaultProps = {
  activeIndex: null,
  onChange: null,
};

export default Tabs;
